import { useParams } from 'react-router-dom';

import { AppWPLeaderboardPage } from '~/components/pages/AppWPLeaderboardPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppWPLeaderboardRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppWPLeaderboardPage appId={appId} />
    </DashboardTemplate>
  );
};
